import styled from 'styled-components';
import { DEVICES } from '../../../config/appConfig';
import Cards from '../../Cards/Cards';

export const StyledCard = styled(Cards)`
  width: 100%;
  height: max-content;
  padding: 0px;
  box-shadow: none;
  background: ${({ background }) =>
    background ||
    'linear-gradient(323deg, rgba(27,25,24,1) 0%, rgba(0,0,0,1) 87%, rgba(113,58,0,1) 100%)'};
`;

export const StyledContainer = styled.div`
  display: flex;
  font-family: Rubik;
  padding-top: 24px;
  justify-content: space-around;
  align-items: ${({ positionStyle }) =>
    positionStyle ? 'center' : 'flex-end'};
  @media ${DEVICES.tablet} {
    width: 100%;
    flex-direction: column;
    align-items: center;
    padding-top: 32px;
    gap: 30px;
  }

  @media ${DEVICES.mobile} {
    width: 100%;
    flex-direction: column;
    align-items: center;
    padding-top: 32px;
    gap: 16px;
  }
`;

export const StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  color: ${({ colors }) => colors};

  .info {
    height: 38px;
    border-radius: 35px;
    border: 2px solid #ff9b70;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    background-color: white;
    color: rgba(255, 81, 6, 1);
    margin-bottom: 12px;
    padding: 0px 20px;
    width: fit-content;
    font-size: 16px;
  }

  .title_wh {
    font-size: 36px;
    font-weight: 500;
    color: ${({ colors }) => colors};
  }

  .title_or {
    color: #f58220;
    font-size: 36px;
    font-weight: 500;
  }

  &.content {
    flex-direction: row;
    gap: 10px;
    margin: 12px 0px;
    align-items: center;
    color: ${({ colors }) => colors};
  }

  &.title_mid {
    font-size: 24px;
    font-weight: 500;
    color: ${({ colors }) => colors};
  }

  &.title_s {
    font-size: 16px;
    font-weight: 400;
    color: ${({ colors }) => colors};
  }

  .hero_img {
    width: 100%;
    max-width: 400px;
    height: auto;
    object-fit: contain;
    align-self: center;
  }
  .imageStyle {
    padding-bottom: 28px;
  }
  .right {
    width: 100%;
  }

  &.left {
    justify-content: center;
    align-self: center;
    padding: 24px 0px;
  }
  .iconImage {
    width: 48px;
    height: 48px;
  }

  @media ${DEVICES.tablet} {
    &.left {
      width: 100%;
      padding: 0px 0px;
    }
    .right {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .hero_img {
      width: 80%;
      max-width: 300px;
    }
    .title_wh {
      font-size: 32px;
    }

    .title_or {
      font-size: 32px;
    }
    &.title_mid {
      font-size: 22px;
      font-weight: 500;
    }
    .iconImage {
      width: 48px;
      height: 48px;
    }

    &.title_s {
      font-size: 14px;
      font-weight: 400;
    }
  }

  @media ${DEVICES.mobile} {
    &.left {
      width: 100%;
    }
    .right {
      width: 100%;
    }
    .hero_img {
      width: 70%;
      max-width: 250px;
    }
    .title_wh {
      font-size: 28px;
    }

    .title_or {
      font-size: 28px;
    }
    &.title_mid {
      font-size: 20px;
    }
    &.title_s {
      font-size: 14px;
    }
    .iconImage {
      width: 40px;
      height: 40px;
    }
    .info {
      height: 30px;
      border: 2px solid #ff9b70;
      font-size: 12px;
    }
  }

  @media ${DEVICES.sMobile} {
    &.left {
      width: 100%;
    }
    .right {
      width: 100%;
    }
    .hero_img {
      width: 70%;
      max-width: 250px;
    }
    .title_wh {
      font-size: 24px;
    }

    .title_or {
      font-size: 24px;
    }
    &.title_mid {
      font-size: 18px;
    }
    &.title_s {
      font-size: 12px;
    }
    .iconImage {
      width: 40px;
    }
    .iconImage {
      width: 32px;
      height: 32px;
    }
    .info {
      height: 30px;
      border: 2px solid #ff9b70;
      font-size: 12px;
    }
  }
`;
